import LayoutListItem from "./LayoutListItem"
import Loader from "../Loader/Loader"
import ReviewModerationItem from "../ReviewModeraton/ReviewItem";
import ReviewFilters from "../ReviewModeraton/ReviewFilters";
const LayoutList = (props: any) => {
    const { headers, items, isLoading, moduleUsedIn, filterReviews, emptyMessage } = props;
    const columnCount = headers?.length || 1
    return (
        <>
            <table className="min-w-full divide-y divide-gray-300 mb-[54px]">
                <thead>
                    <tr>
                        {
                            headers && headers.length && headers.map((header: string, index: number) => {
                                return (
                                    <th key={index} scope="col" className=" text-left "> {header} </th>
                                )
                            })
                        }
                    </tr>
                </thead>
                <tbody>
                    {moduleUsedIn === 'reviews' &&
                        <ReviewFilters filterUp={filterReviews} />
                    }

                    {isLoading ?
                        //Loader & empty state live in a cell so the table markup stays valid
                        <tr>
                            <td colSpan={columnCount}><Loader /></td>
                        </tr>
                        : !items?.length ?
                            <tr>
                                <td colSpan={columnCount} className="empty-row text-center">
                                    {emptyMessage || "No records found."}
                                </td>
                            </tr>
                            : items.map((item: any, index: any) =>
                                moduleUsedIn == 'reviews' ?
                                    <ReviewModerationItem key={index} index={index} review={item} />
                                    : <LayoutListItem key={index} layout={item} />
                            )}
                </tbody>
            </table>
        </>
    )
}

export default LayoutList
